import { render } from "./PoliticaPrivacidadeComponent.vue?vue&type=template&id=4d47914c&scoped=true"
import script from "./PoliticaPrivacidadeComponent.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidadeComponent.vue?vue&type=script&lang=js"

import "./PoliticaPrivacidadeComponent.vue?vue&type=style&index=0&id=4d47914c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d47914c"]])

export default __exports__